import React, { FC, HTMLAttributes, useContext, useEffect, useState } from "react";

import ApiStateModal from "../../../components/reusable-ui/basic-modal";

import { MESSAGE_TYPE } from "../../../data/constants";
import "./style.scss";
import FileUploadModal from "./file-upload-process/file-upload-modal";
import ReconReportsView from "./reports-view/recon-reports-view";
import ReconReportsCommonView from "./reports-view/recon-report-common-view";
import recon_reports_skeleton from "../../../assets/images/recon-reports-skeleton.gif";
import { useDispatch } from "react-redux";
import {
  getOrderwisePayoutData,
  getReconAggregationData,
  getUploadedReportsMetaData,
} from "../../../redux/slices";
import { RECON_ORDER_TYPES } from "../../../data/accounting-constants";
import ReconHeader from "./header-section";
import ReconAnalytics from "./recon-analytics";
import { ReconContext, ReportsType } from "./recon-context";
import ReconLogsModal from "./file-upload-process/recon-logs-modal";
import ReconFeatureTour from "./feature-tour";
import { getLocalStorage, setLocalStorage } from "../../../utils";
import { RECON_WALKTHROUGH } from "../../../data/local-storage-constants";

const OnlineOrderReconciliation: FC<HTMLAttributes<HTMLDivElement>> = () => {
  const [isFileUploadModalOpen, setIsFileUploadModalOpen] =
    useState<boolean>(false),
    [showReconReports, setShowReconReports] = useState<boolean>(false),
    [loadingCounter, setLoadingCounter] = useState(0),
    [tourStart, setTourStart] = useState(false),
    [selectedAggregator, setSelectedAggregator] = useState(""); // show loader when loadingCounter > 0
  const { reconContextData, selectSingleReport, downloadAndEmailReport } = useContext(ReconContext);
  const filesAlreadyUploaded = reconContextData?.reportsViewData?.uploadedReports?.files?.length > 0 || false;
  const tourCompleted = getLocalStorage(RECON_WALKTHROUGH);


  const dispatch = useDispatch();
  const { reconContextData: { uploadFileModal, reportsViewData, reconLogsModal }, fetchCompletedReportsData, fetchDefaultData, getPendingReportsData } = useContext(ReconContext);
  const isShowCompletedReports = reportsViewData.reportType === ReportsType.done;

  useEffect(() => {
    setTimeout(() => {
      if(!filesAlreadyUploaded && !tourCompleted) {
        setTourStart(true);
      }
    }, 500)
  }, [filesAlreadyUploaded])

  useEffect(() => {
    fetchDefaultData();
    getPendingReportsData();
  }, []);

  function skipTour() {
    setTourStart(false);
    setLocalStorage(RECON_WALKTHROUGH, true);
  }

  const viewReconReports = (payload: any) => {
    fetchReconData(payload);
    setShowReconReports(true);
    setSelectedAggregator(payload.aggregatorType);
  };

  function showLoader() {
    setLoadingCounter((val) => val + 1); // increament loadingCounter
  }

  function hideLoader() {
    setLoadingCounter((val) => val - 1); // decrement loadingCounter
  }

  function fetchReconData(dataToPost: any) {
    const callback = (isSuccess: boolean) => {
      hideLoader();
    };
    // API call to fetch recon aggregation data
    showLoader();
    dispatch(getReconAggregationData({ dataToPost, callback }));

    // API call to fetch orderwise payout data for "unmatched" orders
    showLoader();
    dispatch(
      getOrderwisePayoutData({
        dataToPost: { ...dataToPost, orderType: RECON_ORDER_TYPES[1].type },
        callback,
      })
    );

    // API call to fetch orderwise payout data for "not found" orders
    showLoader();
    dispatch(
      getOrderwisePayoutData({
        dataToPost: { ...dataToPost, orderType: RECON_ORDER_TYPES[2].type },
        callback,
      })
    );
  }

  return (
    <div className={`online-order-recon-container px-[20px] pt-[7px] font-inter overflow-hidden h-full`}>
      {isShowCompletedReports && <ReconHeader />}
      {(tourStart && !filesAlreadyUploaded) && <ReconFeatureTour skipTour={skipTour} />}
      {/* {isShowCompletedReports && <ReconAnalytics />} */}
      <ReconReportsCommonView />
      {uploadFileModal ? (
        <FileUploadModal />
      ) : null}
      {reconLogsModal.modal &&
        <ReconLogsModal />
      }
    </div>
  );
};

export default OnlineOrderReconciliation;
